module.exports = __webpack_public_path__ + "static/media/Graph.631a55fe.svg";